import { render, staticRenderFns } from "./WsExamPermissions.vue?vue&type=template&id=70f648b7"
import script from "./WsExamPermissions.vue?vue&type=script&lang=js"
export * from "./WsExamPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports